var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext, useEffect } from 'react';
import { MenuContext } from './MenuContext';
// Wires a MenuItem to its enclosing Menu: asks the Menu to reveal the item once
// it becomes the active one.
export const useMenu = ({ isActive, menuItemRef, }) => {
    _react_refresh_temp_1();
    const { revealItem } = useContext(MenuContext);
    useEffect(() => {
        if (!isActive) {
            return;
        }
        revealItem(menuItemRef.current);
    }, [isActive, menuItemRef, revealItem]);
};
_react_refresh_temp_1(useMenu, "RPpocXHnwFnLz0vQgSt1d2W4nHA=");
